<template>
  <div class="resp-question" v-if="currentQuestion.uuid">
    <v-navbar :logo="quiz.customer.logo" :darkMode="quiz.dark_mode > 0" />

    <div class="resp-question__wrapper">
      <p
        class="resp-question__title"
        :class="{ 'resp-question__title--send-feedback': send.feedback }"
      >
        {{ send.title ? send.title : currentQuestion.question }}
        <span v-if="send.feedback && send.addPessoalData">
          <br />
          <small>Se quiser, pode deixar seus dados.</small>
        </span>
      </p>

      <div
        v-if="!send.title && currentQuestion.has_confirmation == 1"
        class="confirmation-response"
      >
        <div class="confirmation-response__wrapper">
          <VButtonPessoalData
            title="Sim"
            @click.native="handleUpdateCurrentQuestionHasConfirmation"
          />
          <VButtonPessoalData title="Não" @click.native="handleNextStep" />
        </div>
      </div>

      <div v-else class="resp-question__response">
        <div v-if="send.feedback">
          <div class="row" v-if="send.addPessoalData">
            <div class="col s12 input-resp">
              <input
                type="text"
                class="input-resp__input browser-default"
                placeholder="Seu Nome"
                v-model="form.name"
              />
            </div>
            <div
              class="col s12 input-resp"
              :class="{ 'input-resp--error': errors.first('phone_main') }"
            >
              <input
                type="text"
                class="input-resp__input browser-default"
                placeholder="Seu Telefone"
                name="phone_main"
                v-mask="'(##) # #### - ####'"
                v-validate="'min:17'"
                v-model="form.phone"
              />
              <span class="input-resp__helper-text">{{
                errors.first("phone_main")
              }}</span>
            </div>
          </div>
          <div v-else style="display: flex;">
            <div class="row">
              <div class="col">
                <VButtonPessoalData
                  title="Sim"
                  @click.native="continuePessoalData"
                />
              </div>
              <div class="col">
                <VButtonPessoalData title="Não" @click.native="sendFeedback" />
              </div>
            </div>
          </div>
        </div>
        <component
          v-else
          :is="currentResp.name"
          :key="currentQuestion.uuid"
          :params="currentResp.params ? currentResp.params : ''"
          @continue="continueStep"
        />
      </div>
    </div>

    <div class="resp-question__action">
      <VButton
        title="Voltar"
        :hidden="currentQuestion.position == 0"
        @click.native="backStep"
      />

      <a class="resp-question__cancel-link" href="" @click.prevent="cancel"
        >Cancelar</a
      >

      <VButton
        :title="send.feedback ? 'Finalizar' : 'Avançar'"
        @click.native="handleNextStep"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "RespLinearScale",
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      send: {
        title: "",
        feedback: false,
        addPessoalData: false
      },
      form: {
        quiz: {
          uuid: this.id
        },
        name: "",
        phone: "",
        responses: []
      }
    };
  },
  components: {
    VNavbar: () => import("./components/VNavbar.vue"),
    VButton: () => import("./components/VButton.vue"),
    VButtonPessoalData: () => import("./components/VButtonPessoalData.vue"),
    VLinearScale: () => import("./components/VLinearScale.vue"),
    VBoolean: () => import("./components/VBoolean"),
    VLongAnswer: () => import("./components/VLongAnswer"),
    VMultCheck: () => import("./components/VMultCheck"),
    VShortAnswer: () => import("./components/VShortAnswer")
  },

  computed: {
    ...mapState("Quiz", {
      quiz: state => state.quiz,
      currentQuestion: state => state.currentQuestion,
      sequenceQuestions: state => state.sequenceQuestions,
      responses: state => state.responses
    }),
    ...mapGetters("Quiz", ["currentResp"])
  },
  mounted() {
    if (!this.currentQuestion.uuid) {
      this.$router.push({
        name: "response-externo",
        params: { id: this.id }
      });
    }
  },
  methods: {
    ...mapMutations("Quiz", ["updateQuestion"]),
    ...mapActions("Quiz", ["clearStore"]),
    handleUpdateCurrentQuestionHasConfirmation() {
      this.updateQuestion({
        ...this.currentQuestion,
        has_confirmation: false
      });
    },
    handleNextStep() {
      this.send.feedback ? this.sendFeedback() : this.continueStep();
    },
    async sendFeedback() {
      await this.$validator.validateAll();

      if (!this.errors.items.length > 0) {
        const loader = this.$loading.show({
          loader: "spinner",
          width: 50,
          backgroundColor: "#000",
          color: "#fff"
        });
        try {
          const form = { ...this.form };

          form.phone = form.phone
            ? `+55${form.phone.replace(/[^\d]+/g, "")}`
            : "";

          const responses = this.responses.map(val => {
            if (typeof val.response === "object") {
              let nVal = "";

              val.response.forEach(val => (nVal += `${nVal}|${val}`));

              return {
                ...val,
                response: nVal.substring(1, nVal.length)
              };
            } else {
              return { ...val };
            }
          });

          await this.$http.post("answers", {
            answer: {
              ...form,
              responses
            }
          });

          this.$router.push({ name: "feedback-externo", params: { id: this.id } });
        } catch (e) {
          console.error(e);
        }

        loader.hide();
      }
    },
    cancel() {
      this.clearStore();
      this.$router.push({
        name: "response-externo",
        params: { id: this.id }
      });
    },
    backStep() {
      const question = this.sequenceQuestions.filter(
        val => val.position === this.currentQuestion.position - 1
      );
      if (this.send.feedback) {
        this.send = {
          title: "",
          feedback: false
        };
        return;
      }

      if (question.length > 0) {
        this.updateQuestion(question[0]);
        return;
      }
    },
    continueStep() {
      const question = this.sequenceQuestions.filter(
        val => val.position === this.currentQuestion.position + 1
      );

      if (question.length > 0) {
        this.updateQuestion(question[0]);
      } else {
        this.send.title = "Deseja deixar seus dados pessoais?";
        this.send.feedback = true;
      }
    },
    continuePessoalData() {
      this.send.title = "Dados Pessoais";
      this.send.addPessoalData = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables",
  "~@/assets/scss/components/typography";

.confirmation-response {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__wrapper {
    margin: auto 0;
    display: flex;
    justify-content: center;

    & > button {
      margin: 8px;
    }
  }
}

.resp-question {
  .row {
    margin-bottom: 0;
    .col {
      margin-bottom: 48px;
      @media #{$small-and-down} {
        margin-bottom: 24px;
      }
    }
  }
}

.input-resp {
  &__input {
    min-height: 64px;
    font-size: 24px;
    border: none;
    outline: none;
    background: #d0d0d0;
    border-radius: 8px;
    padding: 16px 32px;
    width: 100%;

    &::placeholder {
      color: #8c8c8c;
    }
  }
  &--error {
    display: flex;
    flex-direction: column;
  }
  &--error > &__input {
    border: 2px solid red;
    margin-bottom: 8px;
  }
  &--error > &__input + &__helper-text {
    font-size: 16px;
    color: red;
  }
}

/* .resp-question__response {
  margin: auto 0;
} */

.resp-question {
  padding: 0 24px 90px 24px;
  background: #eceff1;
  min-height: 100%;
  &__wrapper {
    height: calc(100vh - 160px - 120px);
    display: flex;
    flex-direction: column;
  }

  &__response {
    margin: auto 0;
  }

  &__cancel-link {
    font-size: 2.5vw;
    @media #{$large-and-up} {
        font-size: 1.5vw;
      }
  }

  &__title {
    text-align: center;
    font-size: 6vw;
    color: #242424;
    margin: 32px 0 48px 0;

    @media #{$small-and-down} {
      font-size: 24px;
    }


    @media #{$large-and-up} {
        font-size: 2vw;
    }

    &--send-feedback {
      margin: 32px 0;

      small {
        font-size: 65%;
      }
    }
  }
  &__action {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
  }
}
</style>
